(function ($, window, undefined) {
	//NProgress.configure({ trickleRate: 0.2, trickleSpeed: 800, showSpinner: false });
	if ($('#pgrecursos').length > 0) {

		var
		recusosSlider = {};
		recusosSlider.windowWidth = $(window).width();
		recusosSlider.windowHeight = $(window).height();
		recusosSlider.boxRecursos = $('.box-recursos-principal');
		recusosSlider.boxRecursosWidth = recusosSlider.boxRecursos.outerWidth();
		recusosSlider.idPagina = 0;
		recusosSlider.paginaAtual = 0;

		recusosSlider.init = function () {
			$('.titulo-publicacao-slider, .descricao-publicacao-slider').css({
				width: recusosSlider.boxRecursosWidth * 2,
				left: 0
			});

			recusosSlider.setHeightTitulos();
		};

		recusosSlider.setHeightTitulos = function () {
			recusosSlider.windowWidth = $(window).width();
			recusosSlider.windowHeight = $(window).height();
			recusosSlider.boxRecursos = $('.box-recursos-principal');
			recusosSlider.boxRecursosWidth = recusosSlider.boxRecursos.outerWidth();

			$('.titulo-publicacao-slider .titulos').css({
				height: recusosSlider.windowHeight
			});
			$('.titulo-publicacao-slider .titulos, .descricao-publicacao-slider .descricao').css({
				width: recusosSlider.boxRecursosWidth,
				position: 'relative',
				left: 0
			});
		};

		recusosSlider.next = function (animation) {
			if (animation) {
				$('.titulo-publicacao-slider').animate({
					left: recusosSlider.boxRecursosWidth * (-1)
				}, 600, function () {
					$('.titulo-publicacao-slider .titulos:eq(0)').remove();
					$('.titulo-publicacao-slider').css({
						left: 0
					});
				});

				$('.descricao-publicacao-slider').animate({
					left: recusosSlider.boxRecursosWidth * (-1)
				}, 600, function () {

					$('.descricao-publicacao-slider .descricao:eq(0)').remove();
					$('.descricao-publicacao-slider').css({
						left: 0
					});
				});
			}
		};

		recusosSlider.prev = function (animation) {
			if (animation) {
				$('.titulo-publicacao-slider').css({
					left: recusosSlider.boxRecursosWidth * (-1)
				});
				$('.titulo-publicacao-slider').animate({
					left: 0
				}, 600, function () {
					$('.titulo-publicacao-slider .titulos:eq(1)').remove();
				});

				$('.descricao-publicacao-slider').css({
					left: recusosSlider.boxRecursosWidth * (-1)
				});
				$('.descricao-publicacao-slider').animate({
					left: 0
				}, 600, function () {
					$('.descricao-publicacao-slider .descricao:eq(1)').remove();
				});
			}
		};

		recusosSlider.carregarConteudo = function (pagina, direcao, popstate, init) {

			init = init || false;
			$.ajax({
				url: '/Modulos/ProximaPagina',
				data: { pagina: pagina },
				type: 'POST',
				beforeSend: function () {
					NProgress.configure({ trickleRate: 1, trickleSpeed: 800, showSpinner: false });
					NProgress.start();
				},
				success: function (pag) {
					NProgress.done();

					if (pag !== '') {
						setTimeout(function () {

							if (!init) {
							  if (App.isMobile.any() === null) {
									if (direcao == 'prev') {
										$('.titulo-publicacao-slider').prepend(pag.titulo);
										$('.descricao-publicacao-slider').prepend(pag.descricao);
										recusosSlider.setHeightTitulos();
										recusosSlider.prev(true);
									} else {
										$('.titulo-publicacao-slider').append(pag.titulo);
										$('.descricao-publicacao-slider').append(pag.descricao);
										recusosSlider.setHeightTitulos();
										recusosSlider.next(true);
									}
								}
							} else {
								$('#pgrecursos').addClass('carregado');
								$('.titulo-publicacao-slider').append(pag.titulo);
								$('.descricao-publicacao-slider').append(pag.descricao);
								recusosSlider.setHeightTitulos();
								recusosSlider.next(false);
							}

							var titulo = pagina + ' - Recursos - Advise Brasil';

							if (popstate) {
								var url = window.location.href.split('/Modulos');

								pagina = pagina == 'Index' ? '' : pagina;
								url = '/Modulos/' + pagina;
								history.pushState({ idPagina: recusosSlider.idPagina + 1 }, titulo, url);
								recusosSlider.idPagina++;
							}

							document.title = titulo;
						}, 300);
					}

					if (App.isMobile.any() !== null) {
						setTimeout(function () {
							$('.ir-para-recurso').removeClass('ir-para-recurso');
						}, 500);
					}
				}
			});
		};

		recusosSlider.init();

		$(document).on('click', '.ir-para-recurso', function (e) {
			e.preventDefault();
			var
			pagina = $(this).data('pagina');

			// recusosSlider.carregarConteudo(pagina:string (obrigatorio), direcao:string (obrigatorio ( next | prev )), popstate:bool (obrigatorio), init:bool (opcional));
			recusosSlider.carregarConteudo(pagina, 'next', true);
		});

		$(document).on('click', '.ir-para-tras', function (e) {
			e.preventDefault();

			history.back();
		});

		$(function () {
			/*
			 * Pegar a url e carregar a pagina correta
			 */

			var
			pagina = window.location.href.split('/Modulos/');
			pagina = pagina[1] || 'Index';

			// recusosSlider.carregarConteudo(pagina:string (obrigatorio), direcao:string (obrigatorio ( next | prev )), popstate:bool (obrigatorio), init:bool (opcional));
			recusosSlider.carregarConteudo(pagina, 'next', false, true);
		});

		window.onpopstate = function (event) {
			if (App.isMobile.any() === null) {
				var
				pagina = window.location.href.split('/Modulos/');
				pagina = pagina[1] || 'Index';
				var paginaAtual = event.state !== null ? event.state.idPagina : 0;

				var direcao = paginaAtual > recusosSlider.idPagina ? 'next' : 'prev';

				recusosSlider.idPagina = paginaAtual;

				// recusosSlider.carregarConteudo(pagina:string (obrigatorio), direcao:string (obrigatorio ( next | prev )), popstate:bool (obrigatorio), init:bool (opcional));
				recusosSlider.carregarConteudo(pagina, direcao, false);
				return false;
			}
		};

		$(window).resize(function () {
			recusosSlider.setHeightTitulos();
		});
	}

}(jQuery, window));